import { getTenantConfig } from "./tenant";

// This component returns image Url with origin and base directory
// ex: 'https://stage.starfishsolutions.com/starfish-stage/images/nobody_lg.png' 
// Where origin is 'https://stage.starfishsolutions.com' and base directory is 'starfish-stage'
export const getPhotoURL = (id, photoAvailable) => {
  return (photoAvailable || getTenantConfig('RIT_PHOTO_SERVICE_ENABLED')) && id
    ? `${location.origin}${baseDirectory}instructor/photo.html?type=P&size=F&id=${encodeURIComponent(id)}`
    : `${location.origin}${baseDirectory}images/nobody_lg.png`;
};

export const imageStyle = (id, photoAvailable) => {
  return { backgroundImage: `url(${getPhotoURL(id, photoAvailable)})` };
}

// The component will warn us if we use different props, so we have to encode custom props in a known prop
// which in this case will be ${IMAGE_ID}#${IMAGE_HAS_PHOTO}
export const getSearchResultPhotoUrl = (image, type) => {
  const [id, photoAvailable] = image.split("#");

  // Always call the backend if it is a service
  if ( type === "service" ) return `../instructor/photo.html?type=S&size=F&id=${id}`;
  return (photoAvailable === "true" || getTenantConfig('RIT_PHOTO_SERVICE_ENABLED')) ? `../instructor/photo.html?type=P&size=F&id=${id}` : "../images/nobody_lg.png";
};

export const getServicePhotoUrl = (id) => {
  return  `../instructor/photo.html?type=S&size=F&id=${encodeURIComponent(id)}`;
};

export const serviceImageStyle = (id) => {
  return { backgroundImage: `url(${getServicePhotoUrl(id)})`}
}
